import MediumEditor from './MediumEditor';

export default MediumEditor;